/* unplugin-vue-components disabled */import script from "./sample.vue?vue&type=script&setup=true&lang=js"
export * from "./sample.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__